"use client";

import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../../dialog";
import { Button } from "../../../button";
import { X, Calendar } from "lucide-react";
import EventForm from "./EventForm";
import SuccessMessage from "../SuccessMessage";
import type { EventFormValues } from "../types";
import { DiagnosticButton } from "../../../DiagnosticButton";

interface CreateEventModalProps {
  open: boolean;
  onClose: () => void;
  initialValues: EventFormValues;
  onSubmit: (values: EventFormValues) => Promise<void>;
  isOnline: boolean;
  setIsOnline: (isOnline: boolean) => void;
}

const CreateEventModal = ({
  open,
  onClose,
  initialValues,
  onSubmit,
  isOnline,
  setIsOnline,
}: CreateEventModalProps) => {
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleFormSubmit = async (values: EventFormValues) => {
    setLoading(true);
    await onSubmit({ ...values, isOnline });
    setLoading(false);
    setFormSubmitted(true);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5" />
            {formSubmitted
              ? "Event Created Successfully"
              : "Create Microsoft Event"}
          </DialogTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="absolute right-4 top-4"
          >
            <X className="h-4 w-4" />
          </Button>
        </DialogHeader>

        <DiagnosticButton
          extractComponentProps="deep"
          maxDepth={5}
          additionalMetadata={{
            prop: "Create Microsoft Event",
          }}
        />

        {formSubmitted ? (
          <SuccessMessage />
        ) : (
          <EventForm
            initialValues={{ ...initialValues, isOnline }}
            onSubmit={handleFormSubmit}
            loading={loading}
            isOnline={isOnline}
            setIsOnline={setIsOnline}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CreateEventModal;
